export const parseCircleCsv = (raw: string): string[] => {
  return raw
    .split(',')
    .map((entry) => entry.trim().replace(/^@/, ''))
    .filter((entry) => /^[a-zA-Z0-9_]{1,50}$/.test(entry))
    .filter((v, i, arr) => arr.indexOf(v) === i);
};
